import Cookies from 'universal-cookie';
import {SsoClient} from "../../custom_vendor/sso";
const cookies = new Cookies();

let sessionKey = cookies.get('kjd_session');

export default new SsoClient ({sessionKey: sessionKey});